module.exports = {
  title: "北京师范大学南湖附属学校", // 项目标题
  roleKey: "user_roles", // 角色key localStorage
  menuKey: "menu_info", // 当前选择菜单key localStorage
};
